import React from 'react';
import {Label} from "@fluentui/react";
import ImageUploader from "./ImageUploader";

interface IImageEditorProps {
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    label?: string;
    width?: number | string;
    height?: number | string;
    onClear?: () => void;
    imageId?: string;
    imageType?: string;
}

const ImageEditor: React.FC<IImageEditorProps> = (props) => {
    
    return (  
    <div style={{display: 'inline-block', margin: '10px'}}>
        <Label>{props.label}</Label>
        <div style={{border: props.value ? undefined: '2px solid #ddd', padding: '10px', borderRadius: '5px', display: 'inline-block'}}>
            <ImageUploader {...props} />
        </div>
    </div>);
}

export default ImageEditor;